import React, { Component } from 'react';
import './styles/player-controls-startover.css';
import ChannelInfoLabel from './common/ChannelInfoLabel';
import DirectLabel from './common/DirectLabel';
import TimeLabel from './common/TimeLabel';
import PlayerSlider from './common/PlayerSlider';
import VideoPlayerControl from './common/VideoPlayerControl';
import {
    CONTROL_RECORDING,
    CONTROL_TS_BACKWARD,
    CONTROL_SPEED_BACKWARD,
    CONTROL_PLAY,
    CONTROL_PAUSE,
    CONTROL_EPG,
    CONTROL_LANGUAGE,
    CONTROL_TS_FORWARD,
    CONTROL_SPEED_FORWARD,
} from './common/constants';
import { setSeekInterval } from './seekIntervalUtil';
import TrackerManager from '../../utils/TrackerManager';
import PlayerControlsLogic from './PlayerControlsLogic';
import { AAF_CONTENT_IS_CATCHUP } from '../../AAFPlayer/constants';
import Utils from '../../utils/Utils';
import ChannelStreamUtil from '../../utils/ChannelStreamUtil';
import { playerSettings } from './common/constants';
import EventTimeshift from '../../AAF/Timeshift/EventTimeshift';
import Translator from '../../requests/apa/Translator';
import { Grid, Row, Column, cls } from '../../packages/components';
import {
  updateValuesStorageMount,
  updateValuesStorageUnMount } from 'src/components/Modal/functions/ModalInactivity/index'

class PlayerControlsCatchup extends Component {

    constructor(props) {
        super(props);

        this.props = props;

        this.backward = this.backward.bind(this);
        this.forward = this.forward.bind(this);
        this.speedBackward = this.speedBackward.bind(this);
        this.speedForward = this.speedForward.bind(this);

        this.state = {
            timeshiftEventInfo: null
        }

        this.onExit = this.onExit.bind(this)
        this.play = this.play.bind(this);
        this.pause = this.pause.bind(this);
        this.getCurrentTime = this.getCurrentTime.bind(this);

        this.speedBackwardButtonTitle = Translator.get('playing_playerControls_toolbar_button_rewind', 'Atrasar') ;
        this.speedForwardButtonTitle = Translator.get('playing_playerControls_toolbar_button_forward', 'Adelantar');

        this.backwardButtonTitle = Translator.get('playing_playerControls_toolbar_button_seekTsRewind', 'Atrasar') ;
        this.forwardButtonTitle = Translator.get('playing_playerControls_toolbar_button_seekTsForward', 'Adelantar');

        this.defaultButtons = this.getDefaultButtons();

        this.addEventListeners = this.addEventListeners.bind(this);
        this.removeEventListeners = this.removeEventListeners.bind(this);

        this.slide = this.slide.bind(this);
        this.updateCurrentTimeUI = this.updateCurrentTimeUI.bind(this);
        this.updateCurrentTime = this.updateCurrentTime.bind(this);
        this.sendFowardRewindSeek = this.sendFowardRewindSeek.bind(this);
        this.calculateFinalSeekTime = this.calculateFinalSeekTime.bind(this);
        this.onRateChange = this.onRateChange.bind(this);
        this.watchCurrentTime = this.watchCurrentTime.bind(this);
        this.exitTrickMode = this.exitTrickMode.bind(this);
        this.eventIsRecording = this.eventIsRecording.bind(this);

        this.seekInPause = 0;
        this.seekTime = 0;
        this.seekTotalTime = 0;
        this.currentTime = 0;

        this.timerTimeshitDelayId = null;
        this.isInTrickMode = false;

        // Indica que el user se esta moviendo hacía atrás
        this.backwardIsMoving = false;
        this.delayTimeshiftSeek = 1000; //ms

        const that = this;
        this.seekBarInterval = setSeekInterval(function () {
            if (that.seekTotalTime >= 0 && that.backwardIsMoving) {
                console.log('[NPC] interval seek', that.seekTotalTime);
                //Send stats related to seek (i.e. sumologic)
                that.sendFowardRewindSeek();
                that.seek(that.seekTotalTime);
                that.seekTotalTime = 0;
                that.seekTime = 0;
                that.backwardIsMoving = false;
                // that.setTimer();
            }
            console.log('[PlayerControls] interval before stop after set seek ');
            this.stop();
        }, 2);

        this.paramsModalInactivity = {
          pause: this.pause,
          play: this.play,
          exit : this.onExit,
          clearLoading: this.props.clearLoading,
          toggleEPG: this.props.onEpg,
        }
        this.setIntervalModalInactivity = PlayerControlsLogic.setIntervalModalReproduction(this.paramsModalInactivity)
    }

    onExit(){
      updateValuesStorageUnMount(this.setIntervalModalInactivity)
      this.props.onExit()
    }

    getDefaultButtons() {
        const defaultButtons = [];

        if(this.isFastRewindEnable()) {
            defaultButtons.push({ type: CONTROL_SPEED_BACKWARD, clic: this.speedBackward, enabled: true, title: this.speedBackwardButtonTitle });
        } else {
            EventTimeshift.isSeekOnTSEnabled('catchup') &&  defaultButtons.push({ type: CONTROL_TS_BACKWARD, clic: this.backward, enabled: true, title: this.backwardButtonTitle });
        }
        defaultButtons.push({ type: CONTROL_PLAY, clic: this.play, enabled: true, title: Translator.get('playing_playerControls_toolbar_button_play', 'Reproducir') });
        if(this.isFastRewindEnable()) {
            defaultButtons.push({ type: CONTROL_SPEED_FORWARD, clic: this.speedForward, enabled: true, title: this.speedForwardButtonTitle });
        } else {
            EventTimeshift.isSeekOnTSEnabled('catchup') && defaultButtons.push({ type: CONTROL_TS_FORWARD, clic: this.forward, enabled: true, title: this.forwardButtonTitle });
        }
        defaultButtons.push({ type: CONTROL_EPG, clic: this.props.onEpg, enabled: true, title: Translator.get('playing_playerControls_toolbar_button_guide', 'Guía'), ref: null });
        defaultButtons.push({ type: CONTROL_LANGUAGE, clic: this.props.onLanguage, enabled: true, title: Translator.get('playing_playerControls_toolbar_button_language', 'Idioma') });

        return defaultButtons;
    }

    updateCurrentTime(currentTime) {
        this.setCurrentTime(currentTime);
        if (!this.backwardIsMoving) {
            this.updateCurrentTimeUI(currentTime);
        }

    }

    setCurrentTime(currentTime) {
        this.currentTime = currentTime;
        this.watchCurrentTime(currentTime);
    }

    getCurrentTime() {
        return this.currentTime;
    }

    getDuration() {
        return this.props.getDuration();
    }

    getBallPosition(ballPercent) {
        if (this.refs['playerSlider']) {
            const width = this.refs['playerSlider'].refs['barContainer'].offsetWidth;
            if (width < 1) return 0;
            const left = (width * ballPercent) / 100;

            return left;
        }

        return 0;
    }

    updateCurrentTimeUI(currentTime) {
        // La posición del ball-slider del user progress
        const ballPercent = PlayerControlsLogic.getPercentProgress(currentTime, this.getDuration());

        if (this.refs['playerSlider']) {
            // % barra avance, el now del usuario (puede ser el mismo que el now del programa)
            this.refs['playerSlider'].refs['progressNow'].style.width = ballPercent + '%';

            // Time start
            this.refs['timeStart'].refs['time'].innerHTML = PlayerControlsLogic.getContentDuration(currentTime, AAF_CONTENT_IS_CATCHUP);

            // Ball position
            this.refs['playerSlider'].refs['ball'].style.left = this.getBallPosition(ballPercent) + 'px';
            // Time end
            this.refs['timeEnd'].refs['time'].innerHTML = PlayerControlsLogic.getContentDuration(this.getDuration(), AAF_CONTENT_IS_CATCHUP);
        }
    }

    /**
     * TODO revisar la condición
     */
    isRecordingEnabled() {
        return true;
    };

    sendFowardRewindSeek() {
        console.log('[NPC] SEND STATS SEEK');
        const { isBackward, seekTime } = this.getOperatorsSeek();

        if (isBackward && (seekTime === 15 || seekTime === 10)) {
            TrackerManager.rewind(this.getCurrentTime());
        } else if (!isBackward && (seekTime === 15 || seekTime === 10)) {
            TrackerManager.foward(this.getCurrentTime());
        }
    }

    /**
     * Resolve enabled buttons
     */
    getVisibleButtons() {
        const params = {
            defaultButtons : this.getDefaultButtons(),
            timeshiftEventInfo : this.state.timeshiftEventInfo,
            addValue : {
                type: CONTROL_RECORDING,
                clic: this.props.onRecording,
                enabled: true,
                title: Translator.get('playing_playerControls_toolbar_button_canRecord', 'Grabar') }
        }
        const auxDefaultButtons = this.props.addRecordingButton( params )
        let visible = auxDefaultButtons.map(
            (button) => {
                if (button.type === CONTROL_PLAY) {
                    if (this.props.playing) {
                        return { type: CONTROL_PAUSE, clic: this.pause, enabled: true, title: Translator.get('playing_playerControls_toolbar_button_pause', 'Pause') };
                    }
                    else {
                        // Por default el botón es play
                        return button;
                    }
                }
                else if (button.type === CONTROL_RECORDING) {
                    let buttonEnabled = null;
                    let buttonText = Translator.get('playing_playerControls_toolbar_button_canRecord', 'Grabar');
                    const recordingStatus = this.props.getEventRecordingStatus();
                    const recordingButton = document.querySelector(".video-player-control-button-recording");
                    switch (recordingStatus) {
                        case 0:
                            buttonEnabled = false;
                            buttonText = Translator.get('playing_playerControls_toolbar_button_canRecord', 'Grabar');
                            recordingButton && recordingButton.classList.remove("video-player-control-with-emphasis");
                            break;
                        case 1:
                            buttonEnabled = true;
                            buttonText = Translator.get('playing_playerControls_toolbar_button_canRecord', 'Grabar');
                            recordingButton && recordingButton.classList.remove("video-player-control-with-emphasis");
                            break;
                        case 2:
                            buttonEnabled = false;
                            buttonText = Translator.get('playing_playerControls_toolbar_button_Scheduled', 'Por grabar');
                            recordingButton && recordingButton.classList.add("video-player-control-with-emphasis");
                            break;
                        case 3:
                            buttonEnabled = true;
                            buttonText = Translator.get('playing_playerControls_toolbar_button_recordingBlink', 'Grabando');
                            recordingButton && recordingButton.classList.add("video-player-control-with-emphasis");
                            break;
                        case 4:
                            buttonEnabled = false;
                            buttonText = Translator.get('playing_playerControls_toolbar_button_inRecord', 'Grabado');
                            recordingButton && recordingButton.classList.add("video-player-control-with-emphasis");
                            break;
                        default:
                            break;
                    }

                    return { type: CONTROL_RECORDING, clic: this.props.onRecording, enabled: buttonEnabled, title: buttonText };
                }
                else
                    return button;
            }
        );

        // Cambio de idioma está disponible?
        if (!this.props.isMultipleLiveLangEnabled()) {
            visible = visible.filter(b => b.type !== CONTROL_LANGUAGE);
        }

        return visible;
    }

    addEventListeners() {
        this.removeEventListeners();
    }

    removeEventListeners() {
    }

    async componentDidMount() {
        await updateValuesStorageMount(AAF_CONTENT_IS_CATCHUP)
        this.addEventListeners();
    }

    resetIntState() {
        this.backwardIsMoving = false;
        this.isInTrickMode = false;
        this.seekInPause = 0;
    }

    componentWillUnmount() {
      this.resetIntState();
      updateValuesStorageUnMount(this.setIntervalModalInactivity)
    }

    componentWillReceiveProps(nProps) {
        console.log('[NPC] Live cmponentWillReceiveProps ', nProps);
    }

    /**
   * Slider side actions
   * @param e
   */
    slide(e) {

        if(!EventTimeshift.isSeekOnTSEnabled('catchup')) {
            return false;
        }

        if (!this.props.enabled) {
            return false;
        }

        console.log('[NPC] Startover slide events en 1, entrando', this.props.visible, this.props.playing);
        if (!this.props.visible) {
            return false;
        }

        this.props.onSlide(null, direction);

        console.log('[NPC] Startover slide events en 2');
        const { direction } = e.detail;
        switch (direction) {
            case 'left':
                e.preventDefault();
                if (this.isInTrickMode) {
                    this.exitTrickMode();
                }
                this.calculateFinalSeekTime(true, playerSettings.getBackwardTimeByStreamtypeTS(AAF_CONTENT_IS_CATCHUP, true));
                break;
            case 'right':
                e.preventDefault();
                if (this.isInTrickMode) {
                    this.exitTrickMode();
                }
                // Si no esta en pausa, live no se mueve hacía adelante
                this.calculateFinalSeekTime(false, playerSettings.getForwardTimeByStreamtypeTS(AAF_CONTENT_IS_CATCHUP, true));
                break;
            default:
                break;
        }
    }

    /**
        * Controles del player
        */
    play() {
        if (!this.props.enabled) return;
        if (this.isInTrickMode) {
            this.exitTrickMode();
            this.props.onPlay(() => {
                this.props.focus('.video-player-control-main-button-pause');
            });

            return;
        }

        this.props.play();

        if (this.seekInPause) {
            Utils.seekInPause(this.props.seek, this.seekInPause);
            this.seekInPause = 0;
        }

        this.props.onPlay(() => {
            this.props.focus('.video-player-control-main-button-pause');
        });
    }

    pause() {
        this.props.pause();
        this.props.onPause(this.getCurrentTime(), () => {
            this.props.focus('.video-player-control-main-button-play');
        });
    }

    isFastRewindEnable() {
        return EventTimeshift.isTrickModeEnabled();
    }

    backward() {
        if (!this.props.enabled) return;
        this.props.onBackward(null);
        this.calculateFinalSeekTime(true, playerSettings.getBackwardTimeByStreamtypeTS(AAF_CONTENT_IS_CATCHUP));
    }

    /**
     * backward en startover es trick mode x2 x4 ...
     * sólo slider-ball hace back y forward sobre el progress del evento
     */
    speedBackward() {
        this.props.onBackward(null);
        if (!this.props.enabled) return;
        if (this.isFastRewindEnable()) {

            // Si player no cargó el video
            if (!this.props.enabled) return;

            // Si está por hacer seek se bloquea el trickPlay
            if (this.backwardIsMoving) {
                return;
            }

            if (this.props.playing || this.isInTrickMode) {
                this.props.speedBackward();
            }
            else {
                this.backwardIsMoving = false;
                this.props.play();
                this.props.onPlay(() => {
                    this.props.speedBackward();
                });
            }
        }
    }

    forward() {
        if (!this.props.enabled) return;
        this.props.onForward(null);
        this.calculateFinalSeekTime(false, playerSettings.getForwardTimeByStreamtypeTS(AAF_CONTENT_IS_CATCHUP));
    }

    /**
     * forward en startover es trick mode x2 x4 ...
     * sólo slider-ball hace back y forward sobre el progress del evento
     */
     speedForward() {
        this.props.onForward(null);
        if (!this.props.enabled) return;
        if (this.isFastRewindEnable()) {
            // Si player no cargó el video
            if (!this.props.enabled) return;

            // Si está por hacer seek se bloquea el trickPlay
            if (this.backwardIsMoving) {
                return;
            }

            if (this.props.playing || this.isInTrickMode) {
                this.props.speedForward();
            }
            else {
                this.backwardIsMoving = false;
                this.props.play();
                this.props.onPlay(() => {
                    this.props.speedForward();
                });
            }
        }
    }

    focusSlider() {
        const resultFocus = this.props.focus('.player-slider-bar-ball');
        if (!resultFocus) {
            //this.focusPlayPauseButton();
        }
    }

    focusPlayPauseButton(btnClass) {
        this.props.focus(btnClass);
    }

    calculateFinalSeekTime(isBackward, seekTime) {
        // TODO this.showSprites(this.canShowSprites());
        console.log(
            '[NPC] Catchup Vemos los nuevos tiempos que se tienen en el player  -isBackward - seekTime ',
            isBackward,
            seekTime
        );
        this.setOperatorsSeek({ isBackward, seekTime });
        // TODO Esto de abajo se debe hacer desde el class father para que muestre la barra
        // TODO this.show();
        let secs = isBackward ? -seekTime : seekTime;
        let curTime = this.getCurrentTime();
        if (this.seekInPause) {
            curTime = this.seekInPause;
        }
        let newSecs = curTime + (this.seekTime += secs);
        if (newSecs < 0) {
            newSecs = 0;
        }
        if (newSecs > this.getDuration()) {
            newSecs = this.getDuration() - 1;
        }
        console.log(
            '[NPC] calculateFinalSeekTime',
            '\nisBackward ' + isBackward,
            '\nnewSeekTime ' + seekTime,
            '\nseekTime ' + this.seekTime,
            '\nnewSecs ' + newSecs,
            '\ncurTime ' + curTime
        );
        this.updateCurrentTimeUI(newSecs);
        // TODO this.updateSprite(newSecs);
        this.doSeek(newSecs, curTime);
        // TODO this.hideSprites();
    }

    doSeek(newSecs, currentTime) {
        console.log(
            '[NPC] Catchup doSeek  ' + '-newSecs ' + newSecs,
            '- currentTime ' + currentTime
        );
        this.seekBarInterval.stop();
        this.seekBarInterval.start();
        this.backwardIsMoving = true;
        this.seekTotalTime = newSecs;
    }

    resetSeekInPause() {
        this.seekInPause = 0;
    }

    seek(time) {
        /**
         * De acuerdo a este commit https://bitbucket.org/dlaargentina/stvreact/commits/9c72921b8d5978e76ad2046d184004a0da4c2122
         * si el player está en currenttime 0, se oculta playerControls (this.hide() y se pone la bandera this.isVisible = false).
         *
         * Pero esto de arriba no permite que se haga un seek a 0 en los primeros 29 segundos de reproducción
         * porque al hacer el seek al time=0 la bandera isVisible ya está en false, por tanto el seek no lo hace.
         * Se agrega validación extra para forzar seek en 0 (con doSeek var de abajo)
         */
        let doSeek = this.props.visible;
        if (time < 1 && !this.props.visible) {
            doSeek = true;
        }

        if ((doSeek) && this.props.enabled) {
            if (!this.props.playing) {
                this.seekInPause = time;
                this.setCurrentTime(this.seekInPause);
            } else {
                this.props.seek(time);
            }
        }
    }

    getSafeTime() {
        const timeshiftMetadata = Utils.getApaMetadataKey('epg_event_safe_time', '{}', 'timeshift');

        if (timeshiftMetadata) {
            return timeshiftMetadata.start;
        }
        else {
            return 0;
        }
    }

    setOperatorsSeek(values) {
        this.valuesSeek = { ...values };
    }

    getOperatorsSeek() {
        return this.valuesSeek;
    }

    /**
   * params = {speed: number, direction: FORWARD|BACKWARD}
   * @param speed
   * @param direction
   * @param frompause
   */
    onRateChange(speed, direction, frompause) {
        speed = Math.abs(speed);
        speed = speed + '';

        let refBackward = `video_control_type_${CONTROL_SPEED_BACKWARD}`;
        let refForward = `video_control_type_${CONTROL_SPEED_FORWARD}`;

        let refBackwardTitle = `video_control_title_${CONTROL_SPEED_BACKWARD}`;
        let refForwardTitle = `video_control_title_${CONTROL_SPEED_FORWARD}`;

        let trickBackward = null;
        let trickForward = null;

        if (this.refs[refBackward] && this.refs[refBackward].refs[refBackwardTitle]) {
            trickBackward = this.refs[refBackward].refs[refBackwardTitle];
        }

        if (this.refs[refForward] && this.refs[refForward].refs[refForwardTitle]) {
            trickForward = this.refs[refForward].refs[refForwardTitle];
        }

        if (!trickBackward || !trickForward) return;

        if (speed != 0) {
            this.isInTrickMode = true;
            if (direction === 'FORWARD') {
                trickBackward.innerText = this.speedBackwardButtonTitle;
                trickForward.innerText = this.speedForwardButtonTitle + ' x' + speed;

                // Se pone botón de play en lugar de botón de pausa
                this.props.onPause(this.getCurrentTime, () => {
                    this.props.focus('.video-player-control-button-forward');
                });
            }
            if (direction === 'BACKWARD') {
                trickForward.innerText = this.speedForwardButtonTitle;
                trickBackward.innerText = this.speedBackwardButtonTitle + ' x' + speed;

                // Se pone botón de play en lugar de botón de pausa
                this.props.onPause(this.getCurrentTime, () => {
                    this.props.focus('.video-player-control-button-backward');
                });
            }
        }
        else {
            this.isInTrickMode = false;
            trickBackward.innerText = this.speedBackwardButtonTitle;
            trickForward.innerText = this.speedForwardButtonTitle;

            // Se pone botón de pausa en lugar de botón de play
            this.props.onPlay(this.getCurrentTime, () => {
                this.props.focus('.video-player-control-main-button-pause');
            });
        }
    }

    /**
     * WatchCurrentTime Aplica para startover, catchup y npvr
     */
    watchCurrentTime(currentTime) {
        if (this.isInTrickMode && currentTime <= 1) {
            this.props.resetAutoHideTimer();
            // break trickmode
            this.exitTrickMode();
        }
    }

    /**
   * Reset trick mode to 0
   */
    exitTrickMode() {
        // Romper el trickmode
        this.props.setSpeed(0);
        // TODO ajustar AUTOHIDE
        // this.forceStopAutoHide = false;
        // this.verifySetAutoHide();
    }

    setTimeshiftEventInfo(timeshiftEventInfo) {
        /**
        * Evento a playear
        */
        let channelNumber = '', channelImage = '', eventTitle = '';
        const groupId = timeshiftEventInfo && timeshiftEventInfo.event ? timeshiftEventInfo.event.group_id : '';

        if (groupId) {
            const channelInfo = ChannelStreamUtil.get(groupId);
            channelNumber = channelInfo ? channelInfo.channel_number || '' : '';
            channelImage = channelInfo ? channelInfo.imageEpg || '' : '';
        }
        eventTitle = timeshiftEventInfo && timeshiftEventInfo.event && timeshiftEventInfo.event.name ? timeshiftEventInfo.event.name : '';
        this.setState({ timeshiftEventInfo }, () => {
            this.updateChannelInfo(channelNumber, channelImage, eventTitle);
        });
    }

    /**
     * Update channel info
     */
    updateChannelInfo(channelNumber, channelIcon, eventTitle) {
        if (this.refs['channelInfoLabel']) {
            if (this.refs['channelInfoLabel'].refs['channelNumber']) this.refs['channelInfoLabel'].refs['channelNumber'].innerHTML = channelNumber;
            if (this.refs['channelInfoLabel'].refs['channelImageUrl']) this.refs['channelInfoLabel'].refs['channelImageUrl'].src = channelIcon;
            if (this.refs['channelInfoLabel'].refs['channelEventTitle']) this.refs['channelInfoLabel'].refs['channelEventTitle'].innerHTML = Utils.cutPlayerString(eventTitle, 30, 28);

            if(channelIcon) {
                this.refs['channelInfoLabel'].refs['channelImageUrl'] && this.refs['channelInfoLabel'].refs['channelImageUrl'].classList.remove('channel-info-label-image-hide');
            }
        }
    }

    eventIsRecording() {
        return this.props.eventIsRecording();
    }

    render() {
        console.log('[NPC2] PC TV render ');
        const visibleButtons = this.getVisibleButtons();

        let defLength = 3;
        let controlsClassName = '';
        if(Array.isArray(visibleButtons)) {
            defLength = visibleButtons.length;
            controlsClassName = `player-controls-width-${defLength}`;
        }

        let ct = 1;

        return (
            <div>
                <Grid className={cls(`player-controls-startover-container`)}>
                    <Row className={cls(`player-controls-startover-channelinfo-wrapper`)}>
                        <ChannelInfoLabel ref="channelInfoLabel" />
                    </Row>
                    <Row className="player-controls-startover-flex-slider-wrapper">
                        <Column lg={1} className={cls(``)}>
                            <TimeLabel ref="timeStart" />
                        </Column>
                        <Column lg={9} className={cls(``)}>
                        {/* La barra Bar Total es la que muestra en un startover, la que muestra el progress del evento respecto al now.  */}
                            <PlayerSlider
                                ref="playerSlider"
                                withBarTotal={false} // La barra que indica el total que lleva el programa a este momento
                                slide={this.slide}
                                ballPercent={this.props.ballPercent}
                            />
                        </Column>
                        <Column lg={1} className={cls(``)}>
                            <TimeLabel customCss="time-label-custom-end" ref="timeEnd" />
                        </Column>
                        <Column lg={1} className={cls(``)}>
                            <DirectLabel type="aaf_content_is_startover" label={Translator.get('playingLive_eventType_description_presentEvent_label', 'AHORA')} />
                        </Column>
                    </Row>
                    <Row>
                        <div className="player-controls-startover-separator"></div>
                    </Row>
                    </Grid>
                    <Grid className={cls(`player-controls-catchup-no-grid-float`)}>
                        <Row className={cls(`player-controls-startover-flex-controls-wrapper ${controlsClassName}`)}>
                        {
                            visibleButtons.map((button, idx, items) => <VideoPlayerControl
                                id={`pc${idx}`}
                                control={button}
                                onClic={button.clic}
                                key={`control_${ct++}`}
                                data={`video_control_type_${button.type}`}
                                ref={`video_control_type_${button.type}`}
                                isRecorded={this.eventIsRecording}
                                nav={this.props.getPlayerControlsButtonNavigation(idx, items, true)}
                            />
                            )
                        }
                    </Row>
                </Grid>
            </div>
        )
    }
}

export default PlayerControlsCatchup;



// WEBPACK FOOTER //
// ./src/playerDomain/components/PlayerControlsCatchup.js